import {
  createClientApi,
  deleteClientApi,
  getClientsApi,
  getSingleClientByIdApi,
  updateClientApi,
} from "api/clients";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  createClientFailure,
  createClientSuccess,
  deleteClientFailure,
  deleteClientSuccess,
  getClientsFailure,
  getClientsSuccess,
  getSingleClientFailure,
  getSingleClientSuccess,
  updateClientFailure,
  updateClientSuccess,
} from "./actions";
import {
  CREATE_CLIENT,
  DELETE_CLIENT,
  GET_CLIENTS,
  GET_SINGLE_CLIENT,
  UPDATE_CLIENT,
} from "./actionTypes";

function* getClientsSaga({ payload }) {
  try {
    const { data } = yield call(getClientsApi, payload);
    yield put(getClientsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getClientsFailure(error));
  }
}

// ===================================================
// ===================================================

function* getSingleClientSaga({ payload }) {
  try {
    const { data } = yield call(getSingleClientByIdApi, payload);
    yield put(getSingleClientSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleClientFailure(error));
  }
}

// ===================================================
// ===================================================

function* createClientSaga({ payload }) {
  try {
    const { data, success } = yield call(createClientApi, payload);
    yield put(createClientSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم إنشاء العميل بنجاح");
      yield payload?.navigate("/clients");
    }
  } catch (error) {
    console.log(error);
    yield put(createClientFailure(error.response.data.errors[0].msg));
    yield payload?.toast?.error(error.response.data.errors[0].msg);
  }
}

// ===================================================
// ===================================================

function* updateClientSaga({ payload }) {
  try {
    const { data, success } = yield call(updateClientApi, payload);
    yield put(updateClientSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم تحديث العميل بنجاح");
      yield payload?.navigate("/clients");
    }
  } catch (error) {
    console.log(error);
    yield put(updateClientFailure(error.response.data.errors[0].msg));
    yield payload?.toast?.error(error.response.data.errors[0].msg);
  }
}

// ===================================================
// ===================================================

function* deleteClientSaga({ payload }) {
  try {
    yield call(deleteClientApi, payload);
    yield put(deleteClientSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteClientFailure(error.response.data.errors[0].msg));
    yield payload?.toast?.error(error.response.data.errors[0].msg);
  }
}

// ===================================================
// ===================================================

export function* watchGetClients() {
  yield takeEvery(GET_CLIENTS, getClientsSaga);
}

export function* watchGetSingleClient() {
  yield takeLatest(GET_SINGLE_CLIENT, getSingleClientSaga);
}

export function* watchCreateClient() {
  yield takeLatest(CREATE_CLIENT, createClientSaga);
}

export function* watchUpdateClient() {
  yield takeLatest(UPDATE_CLIENT, updateClientSaga);
}
export function* watchDeleteClient() {
  yield takeLatest(DELETE_CLIENT, deleteClientSaga);
}

// ===================================================
// ===================================================

function* clientsSaga() {
  yield all([fork(watchGetClients)]);
  yield all([fork(watchGetSingleClient)]);
  yield all([fork(watchDeleteClient)]);
  yield all([fork(watchUpdateClient)]);
  yield all([fork(watchCreateClient)]);
}

export default clientsSaga;
